import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatChipInputEvent } from "@angular/material/chips";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { map, startWith } from "rxjs/operators";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { UntypedFormControl } from "@angular/forms";
import { Observable } from "rxjs";

@Component({
    selector: 'app-weave-tags',
    templateUrl: './weave-tags.component.html',
    styleUrls: ['./weave-tags.component.scss'],
    standalone: false
})
export class WeaveTagsComponent implements OnInit {
  @Input() label: string = "Tags";
  @Input() placeholder: string = "New Tag...";
  @Input() disabledFlag: boolean = false;
  @Input() tags: Tag[];
  @Input() allTags: Tag[];
  @Output() savedTags: EventEmitter<Tag[]> = new EventEmitter<Tag[]>();

  separatorKeysCodes: number[] = [ENTER, COMMA];
  tagsCtrl = new UntypedFormControl();
  filteredTags: Observable<Tag[]>;

  @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;

  constructor() {
    this.filteredTags = this.tagsCtrl.valueChanges.pipe(
    startWith(null),
    map((tagName: string | null) => (tagName ? this._filter(tagName) : this.allTags.slice())),
  ); }

  ngOnInit() {
    //
  }


  removeTag(tag) {
    if(tag.requestKey != "") {
      this.tags = this.tags.filter( item => {
        return item.requestKey != tag.requestKey;
      } );
      let index = this.allTags.findIndex(existingTag => {
        return tag.requestKey == existingTag.requestKey;
      });
      if(index) {
        this.allTags[index].selected = false;
      }
    } else { //remove one of the new ones
      this.tags = this.tags = this.tags.filter( item => {
        return item.name.toLowerCase() != tag.name.toLowerCase();
      } );
    }
    this.saveTags();
  }

  addTag(event: MatChipInputEvent): void { //add new tag
    const value = (event.value || '').trim();
    // Add our tags
    if (value) {
      //check if there is already a tag
      let existing = this.allTags.filter(tag => {
        return tag.name.toLowerCase() == value.toLowerCase();
      });

      if(existing.length > 0 ) {
        //not already in the selected list
        if(this.tags.filter(tag => {
          return tag.name.toLowerCase() == value.toLowerCase();
        }).length == 0 ) {
          console.log(existing[0])
          this.tags.push(existing[0]);
          this.tagInput.nativeElement.value = '';
          this.tagsCtrl.setValue( null );

          let index = this.allTags.findIndex(existingTag => {
            return existing[0].requestKey == existingTag.requestKey;
          });
          if(index) {
            this.allTags[index].selected = true;
          }
        }
      } else {
        //otherwise add a brand new tag
        this.tags.push( { name: value, requestKey: "", selected: false } );
        //todo create the tag for backend, too
        //Note by Vag 6/7/2022: I think this is working fine now
      }
    }

    // Clear the input value
    this.tagInput.nativeElement.value = '';
    this.saveTags();
  }
  selectedTag(event: MatAutocompleteSelectedEvent): void { //add existing tag
    if(this.tags.filter(tag => {
      return tag.requestKey == event.option.value;
    }).length == 0) {
      this.tags.push( { name: event.option.viewValue, requestKey: event.option.value, selected: true } );
      let index = this.allTags.findIndex(existingTag => {
        return event.option.value == existingTag.requestKey;
      });
      if(index >= 0) {
        this.allTags[index].selected = true;
      }
      this.saveTags();
    }
    this.tagInput.nativeElement.value = '';
    this.tagsCtrl.setValue( null );
  }

  saveTags() {
    this.savedTags.emit(this.tags);
  }


  private _filter(value: string): Tag[] {
    const filterValue = value.toLowerCase();
    return this.allTags.filter(tag => { return tag.name.toLowerCase().includes(filterValue) });
  }
}

export interface Tag {
  name: string,
  requestKey: string,
  selected: boolean
}
